import { memo, useState } from 'react';
import { Document, Page } from 'react-pdf';

import {
  PdfRenderContainer,
  Controll,
  DocumentNavigation,
} from './pdf-renderer.styled';
import { RendererPropsData } from '../../types';

interface PdfRendererProps {
  fileObj: RendererPropsData;
  withControl?: boolean;
}

export const PdfRenderer = memo(({ fileObj }: PdfRendererProps) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [currentCanvasWidth, setCurrentCanvasWidth] = useState<number>(0);
  const [showControl, setShowControl] = useState<boolean>(false);

  function onDocumentLoadSuccess({ numPages }: { numPages: any }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset: any) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  return (
    <PdfRenderContainer className={'pdf-container'}>
      <Document
        file={fileObj.file}
        loading={() => null}
        onLoadSuccess={onDocumentLoadSuccess}
        className={'pdf-document'}
      >
        <Page
          pageNumber={pageNumber}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          onRenderSuccess={(PDFPageProxy) => {
            setCurrentCanvasWidth(PDFPageProxy._pageInfo.view[2]);
            setShowControl(true);
          }}
          loading={() => setShowControl(false) as any}
        />
      </Document>
      {showControl && (
        <Controll currentCanvasWidth={currentCanvasWidth}>
          <p>
            Страница {pageNumber || (numPages ? 1 : '--')} из {numPages || '--'}
          </p>
          <DocumentNavigation>
            <button
              type="button"
              disabled={pageNumber <= 1}
              onClick={() => changePage(-1)}
            >
              <i className="fas fa-caret-left" style={{ color: '#42464d' }}></i>
            </button>
            <button
              type="button"
              disabled={pageNumber >= numPages}
              onClick={() => changePage(1)}
            >
              <i
                className="fas fa-caret-right"
                style={{ color: '#42464d' }}
              ></i>
            </button>
          </DocumentNavigation>
        </Controll>
      )}
    </PdfRenderContainer>
  );
});
